import script from "./CreateCS.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateCS.vue?vue&type=script&setup=true&lang=js"

import "./CreateCS.vue?vue&type=style&index=0&id=77eadda4&lang=css"

const __exports__ = script;

export default __exports__